module.exports = __webpack_public_path__ + "static/img/Prescription.69a2ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Prescription.jpg
// module id = /0q4
// module chunks = 7